import { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { LoadingOverlay } from "@components/loading-overlay";
import { TopNav } from "@components/top-nav";
import { getPgCampaigns, getPgOperator, hasPgToken, pgLogout, toPgError } from "../pgApi";

/**
 * PG 登入後的落地頁：列出未結束的活動讓 PG 選；只有一個活動時直接進兌換頁。
 */
const PgHomePage = () => {
	const navigate = useNavigate();
	const operator = getPgOperator();

	const [campaigns, setCampaigns] = useState(null);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		(async () => {
			try {
				const res = await getPgCampaigns();
				setCampaigns(res.campaigns);
			} catch (error) {
				if (!hasPgToken()) {
					navigate("/pg/login", { replace: true });
					return;
				}
				setErrorMessage(toPgError(error).message);
				setCampaigns([]);
			}
		})();
	}, [navigate]);

	const onLogout = async () => {
		await pgLogout();
		navigate("/pg/login", { replace: true });
	};

	if (campaigns?.length === 1) {
		return <Navigate to={`/pg/${campaigns[0].code}`} replace />;
	}

	return (
		<div className="flex min-h-svh flex-col bg-white">
			<TopNav />
			<header className="flex items-center justify-between border-y border-[#e5e5e5] px-5 py-4">
				<div>
					<p className="noto-sans-tc-medium text-[17px] text-[#292929]">現場兌換</p>
					<p className="text-[12px] text-[#a5a5a5]">{operator?.name}</p>
				</div>
				<button className="text-[13px] text-[#5c5c5c] underline" onClick={onLogout}>
					登出
				</button>
			</header>

			<main className="flex-1 px-5 py-6">
				{errorMessage && (
					<p className="mb-4 rounded-[6px] bg-[#fff1f1] p-4 text-center text-[#ff4750]">
						{errorMessage}
					</p>
				)}

				{campaigns?.length === 0 && !errorMessage && (
					<p className="rounded-[6px] bg-[#f4f4f4] p-6 text-center text-[15px] text-[#5c5c5c]">
						目前沒有進行中的活動
					</p>
				)}

				{campaigns?.length > 1 && (
					<>
						<p className="mb-3 text-[14px] text-[#5c5c5c]">請選擇活動</p>
						<ul className="space-y-3">
							{campaigns.map((campaign) => (
								<li key={campaign.code}>
									<Link
										to={`/pg/${campaign.code}`}
										className="flex items-center justify-between rounded-[8px] border border-[#e5e5e5] px-4 py-4"
									>
										<span className="noto-sans-tc-medium text-[16px] text-[#292929]">
											{campaign.name}
										</span>
										<span
											className={
												"rounded-full px-3 py-1 text-[12px] " +
												(campaign.is_redeem_open
													? "bg-[#eef8f0] text-[#1f7a35]"
													: "bg-[#f4f4f4] text-[#a5a5a5]")
											}
										>
											{campaign.is_redeem_open ? "兌換中" : "暫停中"}
										</span>
									</Link>
								</li>
							))}
						</ul>
					</>
				)}
			</main>

			<LoadingOverlay visible={campaigns === null} />
		</div>
	);
};

export default PgHomePage;
